import { moduleFactory } from "@/factories/module";
import {
  hasPreviouslyVisitedLoginPage,
  recordVisitingLoginPage,
} from "@/modules/local-storage/landingPage";
import {
  _writeLocalStoragePendingRedirectPath,
  _clearLocalStoragePendingRedirectPath,
  _readLocalStoragePendingRedirectPath,
} from "@/modules/local-storage/redirect";
import {
  writeUpgradedUserEmail,
  clearUpgradedUserEmail,
  readUpgradedUserEmail,
} from "@/modules/local-storage/upgraded-user-email";
import {
  readStripeLastCheckoutSession,
  writeStripeLastCheckoutSession,
  clearStripeLastCheckoutSession,
} from "@/modules/local-storage/stripe-checkout-session";
import { writeThemeType, clearThemeType, readThemeType } from "@/modules/local-storage/theme";
import {
  writeGoogleCalendarOAuthState,
  readGoogleCalendarOAuthState,
  clearGoogleCalendarOAuthState,
} from "@/modules/local-storage/google-calendar-oauth-state";
import {
  writeOutlookCalendarOAuthState,
  readOutlookCalendarOAuthState,
  clearOutlookCalendarOAuthState,
} from "@/modules/local-storage/outlook-calendar-oauth-state";
import {
  _writeLocalStoragePendingEphemeralRouteAction,
  _clearLocalStoragePendingEphemeralRouteAction,
  _readLocalStoragePendingEphemeralRouteAction,
} from "@/modules/local-storage/ephemeral-route";
import {
  clearIosCalendarSetup,
  readIosCalendarSetup,
  writeIosCalendarSetup,
} from "@/modules/local-storage/ios-calendar-setup";
import {
  clearFromIosApp,
  readFromIosApp,
  writeFromIosApp,
} from "@/modules/local-storage/from-ios-app";
import {
  clearLastUsedAuthMethod,
  readLastUsedAuthMethod,
  writeLastUsedAuthMethod,
} from "@/modules/local-storage/last-used-auth-method";
import {
  writeSlackOAuthContext,
  readSlackOAuthContext,
  writeSlackOAuthState,
  readSlackOAuthState,
  clearSlackOAuthState,
} from "@/modules/local-storage/slack-oauth-state";
import {
  clearMemAgentSlackConnectedModalPending,
  consumeMemAgentSlackConnectedModalPending,
  readMemAgentSlackConnectedModalPending,
  writeMemAgentSlackConnectedModalPending,
} from "@/modules/local-storage/mem-agent-slack-connected-modal";
import {
  clearPendingReminderShillUpsellAttribution,
  readPendingReminderShillUpsellAttribution,
  writePendingReminderShillUpsellAttribution,
} from "@/modules/local-storage/reminder-shill-upsell-attribution";
import {
  clearMemAgentPanelSize,
  readMemAgentPanelSize,
  writeMemAgentPanelSize,
} from "@/modules/local-storage/mem-agent-panel-size";
import {
  clearMemAgentComposerDraft,
  readMemAgentComposerDraft,
  requestMemAgentComposerDraft,
  subscribeMemAgentComposerDraftRequests,
  writeMemAgentComposerDraft,
} from "@/modules/local-storage/mem-agent-composer-draft";
import {
  readMemAgentNewMessageSoundEnabled,
  writeMemAgentNewMessageSoundEnabled,
} from "@/modules/local-storage/mem-agent-new-message-sound";
import {
  clearIntentOnboardingSignupReceipt,
  hasIntentOnboardingSignupReceipt,
  writeIntentOnboardingSignupReceipt,
} from "@/modules/local-storage/intent-onboarding-signup-receipt";

export const localStorageModule = moduleFactory.create({
  writePendingRedirectPath: _writeLocalStoragePendingRedirectPath,
  clearPendingRedirectPath: _clearLocalStoragePendingRedirectPath,
  readPendingRedirectPath: _readLocalStoragePendingRedirectPath,
  writePendingEphemeralRouteAction: _writeLocalStoragePendingEphemeralRouteAction,
  clearPendingEphemeralRouteAction: _clearLocalStoragePendingEphemeralRouteAction,
  readPendingEphemeralRouteAction: _readLocalStoragePendingEphemeralRouteAction,
  writeUpgradedUserEmail,
  clearUpgradedUserEmail,
  readUpgradedUserEmail,
  recordVisitingLoginPage,
  hasPreviouslyVisitedLoginPage,
  readStripeLastCheckoutSession,
  writeStripeLastCheckoutSession,
  clearStripeLastCheckoutSession,
  writeThemeType,
  clearThemeType,
  readThemeType,
  writeGoogleCalendarOAuthState,
  readGoogleCalendarOAuthState,
  clearGoogleCalendarOAuthState,
  writeOutlookCalendarOAuthState,
  readOutlookCalendarOAuthState,
  clearOutlookCalendarOAuthState,
  writeIosCalendarSetup,
  readIosCalendarSetup,
  clearIosCalendarSetup,
  writeFromIosApp,
  readFromIosApp,
  clearFromIosApp,
  writeLastUsedAuthMethod,
  readLastUsedAuthMethod,
  clearLastUsedAuthMethod,
  writeSlackOAuthContext,
  readSlackOAuthContext,
  writeSlackOAuthState,
  readSlackOAuthState,
  clearSlackOAuthState,
  writeMemAgentSlackConnectedModalPending,
  readMemAgentSlackConnectedModalPending,
  clearMemAgentSlackConnectedModalPending,
  consumeMemAgentSlackConnectedModalPending,
  writePendingReminderShillUpsellAttribution,
  readPendingReminderShillUpsellAttribution,
  clearPendingReminderShillUpsellAttribution,
  writeMemAgentPanelSize,
  readMemAgentPanelSize,
  clearMemAgentPanelSize,
  writeMemAgentComposerDraft,
  readMemAgentComposerDraft,
  clearMemAgentComposerDraft,
  requestMemAgentComposerDraft,
  subscribeMemAgentComposerDraftRequests,
  readMemAgentNewMessageSoundEnabled,
  writeMemAgentNewMessageSoundEnabled,
  writeIntentOnboardingSignupReceipt,
  hasIntentOnboardingSignupReceipt,
  clearIntentOnboardingSignupReceipt,
});
